const apiUrls = {
  /* auth */
  ssoLogin: '/sso/login/',
  loginV2: '/v2-auth/',
  login: '/auth/ambassador/',
  forgotPassword: 'auth/ambassador/forgot_password/',
  user: '/users/',
  accounts: '/users/companies/?page_size=200',
  notifications: '/ambassadors/',
  changePassword: '/password/',
  accountActivation: '/active/',
  session: '/auth/session/',
  register: '/register/',
  resetPassword: '/auth/ambassador/reset_password/',
  /* companies */
  companies: '/companies/',
  companyByHost: '/portal.json?host=',
  companyByUid: '/portal.json?uid=',
  /* campaigns */
  campaignsContent: '/tables/content/campaign/',
  campaignsOptions: '/tables/options/campaign/',
  contactsContent: '/tables/content/contact/',
  contactsOptions: '/tables/options/contact/',
  campaignStats: '/stats/campaigns/',
  /* ambassador profile */
  ambassadorProfile: '/ambassadors/',
  ambassadorPortalProfile: '/portal/ambassadors/',
  ambassadorPortalTaxContext: (uid: number) => `/portal/ambassadors/${uid}/tax/context/`,
  /* customer advocacy */
  customerAdvocacyBadges: '/badges/',
  /* loyalty */
  loyaltyBadges: '/loyalty_program/badges/',
  loyaltyTiers: '/loyalty_program/tiers/',
  loyaltyTasks: '/tasks/',
  /* Commissions */
  commissions: '/commissions/',
  /* Payouts */
  payouts: '/payouts/',
  payoutDetails: (id: number) => `/payouts/${id}/`,
  /* Assets */
  assets: '/marketing/',
  /* Assets */
  statsGraphMetrics: '/stats/graph/',
  /* Share */
  shareOptions: '/tables/options/custom_url/',
  share: '/tables/content/custom_url/',
  shareCreate: (uid: number) => `/tables/ambassadors/${uid}/actions/custom_url/create/`,
  shares: '/custom_urls/',
  recentActivites: '/activity/recent/',
  urls: '/urls/',
  trackShareClick: '/track/share/',
  /* Rewards */
  rewards: '/content/affiliate_gift_card/',
  redeemRewardProxy: (ambassadorUid: number) => `/api/rewards/${ambassadorUid}/redeem`,
  redemptionDetails: (id: number) => `/loyalty/gift-card-redemption/${id}/`,
  activityPortal: '/activity/portal/',
  unsubscribe: '/optout/',
  /* Rewards V3 (proxied through Next.js API to avoid CORS) */
  getVaultItemRewards: (ambassadorUid: number) => `/api/rewards/${ambassadorUid}/vault-items`,
  getVaultItemBalance: (ambassadorUid: number, id: number) => `/api/rewards/${ambassadorUid}/vault-items/${id}/balance`,
  redeemVaultItemReward: (ambassadorUid: number, variantId: number) => `/api/rewards/${ambassadorUid}/vault-items/${variantId}/redeem`,
  getRedemptionDetail: (ambassadorUid: number, id: number) => `/api/rewards/${ambassadorUid}/redemptions/${id}`,
  // storefront auth (proxied through Next.js API to avoid CORS)
  storefrontValidation: '/api/storefront/validation',
  storefrontLogin: '/api/storefront/login',
};

export default apiUrls;
